import { AfterViewInit, Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as $ from 'jquery';
import { AuthService } from 'src/app/_services/auth.service';
import { NotificationsService } from 'src/app/_services/notifications.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { RoleService } from 'src/app/_services/role.service';
import { Partner } from 'src/app/_types/partner.type';
import { Roles } from 'src/app/enums/roles.enum';

import { Globals } from '../../../globals';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements AfterViewInit {
  currentUrl: any = '';

  user: any;

  Roles = Roles;

  private _navbarOpen = false;

  get navbarOpen() {
    return this._navbarOpen;
  }

  set navbarOpen(value: boolean) {
    this._navbarOpen = value;
    if (value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  isMobile = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: { innerWidth: any } }) {
    this.isMobile = event.target.innerWidth <= 991;
  }

  constructor(
    private router: Router,
    private globals: Globals,
    private roleService: RoleService,
    protected notificationsService: NotificationsService,
    private profileservice: ProfileService,
    private AuthService: AuthService
  ) {
    this.user = this.globals.getUser();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.navbarOpen = false;
      }
    });
    this.isMobile = window.innerWidth <= 991;
  }

  ngAfterViewInit(): void {
    $(document).on('click', '.nav-item>a', function (e) {
      $(this)
        .parent()
        .toggleClass('menu-open')
        .siblings()
        .removeClass('menu-open');
    });
  }

  ngOnInit(): void {
    this._checkUseRole();
    this._getProfile();
  }

  checkRolePermission: any = [];

  moduleArray: any = [];

  _checkUseRole() {
    const auth = JSON.parse(localStorage.getItem('partner_user') || '{}');
    if (auth.userType === 'PARTNER') {
      return;
    }
    const obj = {
      userId: auth.partnerId,
    };
    this.roleService._getUserRoleByUserId(obj).subscribe((data: any) => {
      this.checkRolePermission = data.data.useCasesList;
      for (let i = 0; i < this.checkRolePermission.length; i++) {
        if (this.checkRolePermission[i].permissionIds.length > 0) {
          this.moduleArray.push(this.checkRolePermission[i].useCaseId);
        }
      }
    });
  }

  SignOut(): void {
    this.AuthService._logout({
      token: this.user?.token,
      hardSignOut: true,
    }).subscribe({
      next: () => {
        this.AuthService.logout();
      },
      error: () => {
        this.AuthService.logout();
      },
    });
  }

  getInitials() {
    if (this.profileData) {
      return (
        (this.profileData.firstName?.toUpperCase()[0] ?? '') +
        (this.profileData.lastName?.toUpperCase()[0] ?? '')
      );
    }
    return '';
  }

  profileData!: Partner;

  _getProfile() {
    this.profileservice._getProfile().subscribe({
      next: (result: any) => {
        if (result.status == 'SUCCESS') {
          this.profileData = result.data;
          this.user = this.globals.getUser();
          if (this.user) {
            this.refreshUnread();
          }
          setInterval(() => {
            this.user = this.globals.getUser();
            if (this.user) {
              this.refreshUnread();
            }
          }, 60000);
        }
      },
      error: (err: any) => {},
      complete: () => {},
    });
  }

  /** Feeds the badge, which reads `notificationsService.unread()`. */
  private refreshUnread(): void {
    this.notificationsService.counts().subscribe({ error: () => {} });
  }
}
